var _ellipse, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 192,
    viewBox: "0 0 193 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.076,
    cy: 87.5749,
    rx: 70.2674,
    ry: 69.9255,
    fill: "#EAEEF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.078 58.7188C161.403 58.7188 164.098 56.0369 164.098 52.7285C164.098 49.4202 161.403 46.7383 158.078 46.7383C154.754 46.7383 152.059 49.4202 152.059 52.7285C152.059 56.0369 154.754 58.7188 158.078 58.7188Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.888 35.342C169.159 35.342 170.999 33.5104 170.999 31.2511C170.999 28.9917 169.159 27.1602 166.888 27.1602C164.618 27.1602 162.777 28.9917 162.777 31.2511C162.777 33.5104 164.618 35.342 166.888 35.342Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2088 28.6948C21.4252 28.6948 24.8433 25.2933 24.8433 21.0974C24.8433 16.9015 21.4252 13.5 17.2088 13.5C12.9923 13.5 9.57422 16.9015 9.57422 21.0974C9.57422 25.2933 12.9923 28.6948 17.2088 28.6948Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.72 63.1137H70.2891V48.9775H119.355C119.446 48.9775 119.536 48.9775 119.626 48.9775C127.293 49.1576 133.516 55.4604 133.516 63.1137H117.281",
    fill: "#CCD4E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18914_253291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.707 48.9775C117.82 49.1576 115.115 50.3281 113.22 52.309C113.04 52.4891 112.86 52.6692 112.679 52.9393C110.966 54.9201 109.703 57.5313 109.703 60.3225V144.419C109.703 152.253 103.389 158.555 95.5421 158.555H26.6328V59.6922C26.8132 56.811 27.8955 54.1998 29.7897 52.309C31.8641 50.2381 34.6602 48.9775 37.817 48.9775H107.177H120.346C120.436 48.9775 120.526 48.9775 120.707 48.9775Z",
    fill: "url(#paint0_linear_18914_253291)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9953 68.2461H75.5209C74.7993 68.2461 74.168 67.6158 74.168 66.8955C74.168 66.1752 74.7993 65.5449 75.5209 65.5449H95.9953C96.7168 65.5449 97.3482 66.1752 97.3482 66.8955C97.3482 67.6158 96.807 68.2461 95.9953 68.2461Z",
    fill: "#B3BFD3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8672 68.2461H39.1693C38.4478 68.2461 37.8164 67.6158 37.8164 66.8955C37.8164 66.1752 38.4478 65.5449 39.1693 65.5449H65.9574C66.6789 65.5449 67.3103 66.1752 67.3103 66.8955C67.3103 67.6158 66.6789 68.2461 65.8672 68.2461Z",
    fill: "#B3BFD3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0035 81.5723H56.3959C55.6743 81.5723 55.043 80.942 55.043 80.2217C55.043 79.5014 55.6743 78.8711 56.3959 78.8711H83.0035C83.7251 78.8711 84.3565 79.5014 84.3565 80.2217C84.4467 80.942 83.8153 81.5723 83.0035 81.5723Z",
    fill: "#B3BFD3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8281 81.5723H39.1693C38.4478 81.5723 37.8164 80.942 37.8164 80.2217C37.8164 79.5014 38.4478 78.8711 39.1693 78.8711H47.8281C48.5497 78.8711 49.181 79.5014 49.181 80.2217C49.181 80.942 48.5497 81.5723 47.8281 81.5723Z",
    fill: "#D4DBEC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9947 94.8975H79.6693C78.9478 94.8975 78.3164 94.2672 78.3164 93.5469C78.3164 92.8266 78.9478 92.1963 79.6693 92.1963H95.9947C96.7163 92.1963 97.3477 92.8266 97.3477 93.5469C97.3477 94.2672 96.8065 94.8975 95.9947 94.8975Z",
    fill: "#D4DBEC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8201 94.8975H39.1693C38.4478 94.8975 37.8164 94.2672 37.8164 93.5469C37.8164 92.8266 38.4478 92.1963 39.1693 92.1963H71.8201C72.5416 92.1963 73.173 92.8266 73.173 93.5469C73.173 94.2672 72.6318 94.8975 71.8201 94.8975Z",
    fill: "#B3BFD3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0049 108.224H65.0561C64.3345 108.224 63.7031 107.593 63.7031 106.873C63.7031 106.153 64.3345 105.522 65.0561 105.522H83.0049C83.7265 105.522 84.3579 106.153 84.3579 106.873C84.4481 107.593 83.8167 108.224 83.0049 108.224Z",
    fill: "#B3BFD3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2084 108.224H39.1693C38.4478 108.224 37.8164 107.593 37.8164 106.873C37.8164 106.153 38.4478 105.522 39.1693 105.522H57.2986C58.0202 105.522 58.6515 106.153 58.6515 106.873C58.6515 107.593 58.0202 108.224 57.2084 108.224Z",
    fill: "#D4DBEC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9917 121.549H83.4545C82.7329 121.549 82.1016 120.919 82.1016 120.198C82.1016 119.478 82.7329 118.848 83.4545 118.848H95.9917C96.7132 118.848 97.3446 119.478 97.3446 120.198C97.3446 120.919 96.8034 121.549 95.9917 121.549Z",
    fill: "#B3BFD3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3372 121.549H54.3217C53.6001 121.549 52.9688 120.919 52.9688 120.198C52.9688 119.478 53.6001 118.848 54.3217 118.848H75.3372C76.0588 118.848 76.6901 119.478 76.6901 120.198C76.6901 120.919 76.0588 121.549 75.3372 121.549Z",
    fill: "#D4DBEC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4752 121.549H39.1693C38.4478 121.549 37.8164 120.919 37.8164 120.198C37.8164 119.478 38.4478 118.848 39.1693 118.848H46.4752C47.1967 118.848 47.8281 119.478 47.8281 120.198C47.8281 120.919 47.1967 121.549 46.4752 121.549Z",
    fill: "#B3BFD3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0069 134.875H70.56C69.8384 134.875 69.207 134.245 69.207 133.524C69.207 132.804 69.8384 132.174 70.56 132.174H83.0069C83.7285 132.174 84.3599 132.804 84.3599 133.524C84.45 134.245 83.8187 134.875 83.0069 134.875Z",
    fill: "#B3BFD3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3496 134.875H39.1693C38.4478 134.875 37.8164 134.245 37.8164 133.524C37.8164 132.804 38.4478 132.174 39.1693 132.174H62.3496C63.0711 132.174 63.7025 132.804 63.7025 133.524C63.7025 134.245 63.0711 134.875 62.3496 134.875Z",
    fill: "#D4DBEC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2369 147.391H83.4564C83.4564 150.452 84.7191 153.243 86.7034 155.224C88.6877 157.295 91.4838 158.465 94.5504 158.465H12.5628C9.49614 158.465 6.70008 157.205 4.71578 155.224C2.73149 153.243 1.46875 150.452 1.46875 147.391H55.4056C55.4056 147.391 65.4173 147.481 65.2369 147.391Z",
    fill: "#CCD4E2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M164.481 71.9441C163.679 75.404 162.475 78.7309 161.004 81.7917C157.126 88.9778 151.376 94.8331 144.155 98.4261C136.666 102.285 127.84 103.616 118.88 101.886C98.0192 97.4946 84.5128 77.2671 88.9258 56.3742C93.3388 35.4813 113.531 22.0407 134.526 26.4322C142.015 28.0291 148.568 31.6222 154.05 36.8121C163.144 46.1274 167.022 59.3019 164.481 71.9441Z",
    fill: "url(#paint1_linear_18914_253291)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M127.407 42.2354C123.797 42.2354 120.988 45.2961 121.256 48.8891L123.262 70.4474C123.396 72.5766 125.268 74.3066 127.407 74.3066C129.547 74.3066 131.419 72.5766 131.553 70.4474L133.559 48.8891C133.826 45.163 131.018 42.2354 127.407 42.2354Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M127.408 78.2988C124.733 78.2988 122.594 80.428 122.594 83.0896C122.594 85.7511 124.733 87.8803 127.408 87.8803C130.082 87.8803 132.222 85.7511 132.222 83.0896C132.222 80.428 130.082 78.2988 127.408 78.2988Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M151.655 25.6692C150.599 25.6692 149.754 24.8284 149.754 23.7775V2.65433C149.754 1.60342 150.599 0.762695 151.655 0.762695C152.711 0.762695 153.556 1.60342 153.556 2.65433V23.7775C153.556 24.8284 152.711 25.6692 151.655 25.6692Z",
    fill: "#989FB0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M167.074 41.8526C167.074 40.8017 167.919 39.9609 168.975 39.9609H190.202C191.258 39.9609 192.102 40.8017 192.102 41.8526C192.102 42.9035 191.258 43.7442 190.202 43.7442H168.975C167.919 43.7442 167.074 42.9035 167.074 41.8526Z",
    fill: "#989FB0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M165.383 28.1913C164.643 27.4557 164.643 26.1946 165.383 25.459L180.484 10.5361C181.223 9.80047 182.49 9.80047 183.23 10.5361C183.969 11.2717 183.969 12.5328 183.23 13.2685L168.234 28.1913C167.389 28.927 166.122 28.927 165.383 28.1913Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18914_253291",
    x: 4.63281,
    y: 37.9775,
    width: 138.074,
    height: 153.578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18914_253291"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18914_253291",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18914_253291",
    x1: 73.6391,
    y1: 46.4429,
    x2: 73.6391,
    y2: 159.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18914_253291",
    x1: 88.0462,
    y1: 64.1058,
    x2: 165.22,
    y2: 64.1058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileWarning);
export default __webpack_public_path__ + "static/media/FileWarning.62a14d83fe0879ecd223ccf1df33132b.svg";
export { ForwardRef as ReactComponent };